import './components/Cookiebar'
import './components/DynamicForm'
import './components/FAQ'
import './components/Lightbox'
import './components/ImageSlider'
import './components/Shops'

addEventListener('DOMContentLoaded', () => {

	//add scroll on load
	if (window.pageYOffset >= 200) {
		document.body.classList.add('scrolled');
	} 

	//active menu 
	const menuItems = document.querySelectorAll('.main-navigation>ul>li')

	if (menuItems) {
		Array.from(menuItems).map(el => {
			if (!el.classList.contains('d-none')) {
				el.addEventListener('click', function (e) {
					makeActive(e)
				})
			}
		})
	}

	function makeActive(e) {
		Array.from(menuItems).map(el => {
			if (el.classList.contains('active-menu')) {
				el.classList.remove('active-menu')
			}
		})
		e.target.parentNode.classList.add('active-menu')
		document.body.classList.toggle('menu-open');

	}

	//active menu on reload
	if (window.location.href.indexOf('#') >= 0) {
		const currentActive = window.location.href.split("#")[1]
		Array.from(menuItems).map((el) => {
			let currentTitle = el.children[0].getAttribute('title').toLowerCase()
			currentTitle.indexOf(currentActive) >= 0 ? el.classList.add('active-menu') : ''

		})
	}

	// hamburger mobile menu
	if (document.querySelector('.main-navigation-mobile')) {
		let hamburgerMain: HTMLElement = document.querySelector('.main-navigation-mobile');
		let closeMenuButton = document.getElementsByClassName('close-menu-btn')[0];

		hamburgerMain.addEventListener('click', function () {
			document.body.classList.toggle('menu-open');
			document.body.classList.remove('scrolled');
		});

		closeMenuButton.addEventListener('click', () => {
			document.body.classList.toggle('menu-open');

		})
	}

	const header = document.querySelector('header')

	// Allow double tapping for mobile users.
	const parentItems: NodeListOf<HTMLElement> = header.querySelectorAll('li.has-children > a');

	for (let a = 0; a < parentItems.length; a++) {
		let active = false;


		parentItems[a].addEventListener('click', function (this: any, event: PointerEvent) {

			if (event.pointerType === 'touch') {

				if (!this.active) {
					event.preventDefault()
				}
				this.active = true
			}
		})

		parentItems[a].addEventListener('mouseleave', function (this: any) {
			this.active = false
		})
	}

	window.addEventListener('resize', () => {
		if (window.innerWidth > 1000) {

			if (document.body.classList.contains('menu-open')) {
				document.body.classList.remove('menu-open');
			}
		}
	})

	//scroll back up
	if (document.getElementsByClassName('arrow-line-up')[0]) {
		let arrowUp = document.getElementsByClassName('arrow-line-up')[0];

		arrowUp.addEventListener('click', function () {
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0;
		})
	}

	//scrolldown 
	if (document.querySelectorAll('#scroll-down>.icon')[0]) {

		let arrowDown = document.querySelectorAll('#scroll-down>.icon')[0]
		let element = document.getElementById("first-section")

		arrowDown.addEventListener('click', function () {
			element.scrollIntoView({ behavior: 'smooth', block: 'center' });
			arrowDown.classList.add('hide')
		})
	}

	//show route google maps 
	if (document.getElementsByClassName("route-button")[0]) {
		let routeButton = document.getElementsByClassName("route-button")[0]
		let desc = document.getElementsByClassName("route")[0]
		let container = document.querySelectorAll(".google-maps-route>.text-content")[0]

		routeButton.addEventListener('click', function () {
			desc.classList.toggle('show')
			routeButton.classList.toggle('show')
			container.classList.toggle('show')
			document.querySelectorAll('.route')[0].scrollTop = 0

		})

		document.querySelectorAll('.route')[0].scrollTop = 0

	}

	window.addEventListener('scroll', () => {
		let arrowDown = document.querySelectorAll('#scroll-down>.icon')[0]

		if (document.documentElement.scrollTop == 0 || document.body.scrollTop == 0) {
			arrowDown.classList.remove('hide')
		}

		if (document.documentElement.scrollTop > 100) {
			arrowDown.classList.add('hide')
		}

		//change menu on scroll 
		if (window.pageYOffset >= 200) {
			document.body.classList.add('scrolled');
		} else {


			if (window.innerWidth > 768) {
				document.body.classList.remove('scrolled');
			}
		}

	})


})

